import { SELECT_LOT_FOR_EDIT, UPDATE_LOT_STORE, ERASE_SUB_LOTS, ERASE_LOT, ERASE_OPTIONALS } from '../types';
import store from '../../store';
import { NegotiationLotAPI } from '../../../API/NegotiationLotsAPI';


export const selectLotForEdit = (oSelectedItem) => dispatch => {
  return dispatch({
    type: SELECT_LOT_FOR_EDIT,
    payload: oSelectedItem
  });
}
export const eraseLotDataFromStore = () => dispatch => {
  dispatch({
    type: ERASE_LOT
  });
  dispatch({
    type: ERASE_SUB_LOTS
  });
  dispatch({
    type: ERASE_OPTIONALS
  });
};


export const saveLot = () => dispatch => {
  const state = store.getState();
  const newObj = JSON.parse(JSON.stringify(state));

  const subLotsDictionary = {
    ...newObj.negotiationSubLots
  }
  // denormalizing the optionals into the DTO for persistence    
  for (var key in subLotsDictionary) {
    if (subLotsDictionary.hasOwnProperty(key)) {
      if (subLotsDictionary[key].ShouldPersist === false) {
        delete subLotsDictionary[key];
        continue;
      }
      subLotsDictionary[key].SubLotCarOptionals = state.subLotCarOptionals[key];
    }
  }

  const negLotDTO = {
    ...state.negotiationLot,
    SubLotsDictionary: subLotsDictionary,
  };

  const negLotAPI = new NegotiationLotAPI();
  return negLotAPI.editNegotiationLot(negLotDTO);
}

export const getMyOwnDataById = (state) => {
  return state.negotiationLot;
}

export const updateLotStore = (propName, propValue) => dispatch => {
  return dispatch({
    type: UPDATE_LOT_STORE,
    payload: { propName, propValue }
  });
}


// WEBPACK FOOTER //
// ./src/store/actions/negotiationLot/negotiationLotActions.js